import axios from "axios";

const DEBUG = false;

async function getRequest(url) {
  if (DEBUG) console.log(`--> GET ${process.env.VUE_APP_API_ENDPOINT}${url}`);
  const response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}${url}`);
  if (DEBUG) console.log("<-- RES", response);
  return response.data;
}
export { getRequest };

async function postRequest(url, payload) {
  if (DEBUG)
    console.log(
      `--> POST ${process.env.VUE_APP_API_ENDPOINT}${url} PAYLOAD`,
      payload
    );
  const response = await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}${url}`,
    payload
  );
  if (DEBUG) console.log("<-- RES", response);
  return response.data;
}
export { postRequest };

async function putRequest(url, payload) {
  if (DEBUG)
    console.log(
      `--> PUT ${process.env.VUE_APP_API_ENDPOINT}${url} PAYLOAD`,
      payload
    );
  const response = await axios.put(
    `${process.env.VUE_APP_API_ENDPOINT}${url}`,
    payload
  );
  if (DEBUG) console.log("<-- RES", response);
  return response.data;
}
export { putRequest };

async function patchRequest(url, payload) {
  if (DEBUG)
    console.log(
      `--> PATCH ${process.env.VUE_APP_API_ENDPOINT}${url} PAYLOAD`,
      payload
    );
  const response = await axios.patch(
    `${process.env.VUE_APP_API_ENDPOINT}${url}`,
    payload
  );
  if (DEBUG) console.log("<-- RES", response);
  return response.data;
}
export { patchRequest };

async function deleteRequest(url, payload) {
  if (DEBUG)
    console.log(
      `--> DELETE ${process.env.VUE_APP_API_ENDPOINT}${url} PAYLOAD`,
      payload
    );
  const response = await axios.delete(
    `${process.env.VUE_APP_API_ENDPOINT}${url}`,
    { data: payload }
  );
  if (DEBUG) console.log("<-- RES", response);
  return response.data;
}
export { deleteRequest };
